import(/* webpackMode: "eager" */ "/var/www/vhosts/blattbild.de/kalender.blattbild.de/cal.com/apps/web/app/global-error.tsx");
